module.exports = __webpack_public_path__ + "static/media/data_science.3c2389f4.svg";